import React, { Component } from 'react';
import BaseInput from '../BaseInput/BaseInput';
import words from '../../../utils/words';

const CLEAVE_SHARES_OPTIONS = {
  numeral: true,
  numeralDecimalScale: 3,
  numeralPositiveOnly: true,
  stripLeadingZeroes: true,
};

export default class SharesInput extends Component {
  constructor(props) {
    super(props);
    this.changeHandler = this.changeHandler.bind(this);
  }
  changeHandler(textValue) {
    const { onChange } = this.props;
    if (onChange) {
      const value =
        textValue === ''
          ? 0
          : textValue === '.'
          ? textValue
          : parseFloat(textValue) === 0
          ? textValue
          : parseFloat(textValue);
      onChange(value);
    }
  }
  render() {
    const {
      inputMode = 'decimal',
      placeholder = words.shares,
      value,
      ...rest
    } = this.props;
    return (
      <BaseInput
        {...rest}
        cleaveOptions={CLEAVE_SHARES_OPTIONS}
        inputMode={inputMode}
        onChange={this.changeHandler}
        placeholder={placeholder}
        value={value === 0 ? '' : value}
      />
    );
  }
}
